import { XCircleIcon } from '@heroicons/react/24/outline';
import { DateRangeSchema } from 'common/hooks/customSearchParams';
import { ButtonDropdown } from 'components/tailwind-ui/ButtonDropdown';
import * as React from 'react';

const dateRangeToLabel = (dateRange: DateRangeSchema): string => {
  if (dateRange.exactDate === 'today') {
    return 'Compare to previous day';
  }
  if (dateRange.exactDate === '-1:days') {
    return 'Compare to day before yesterday';
  }
  if (dateRange.startDate === '-7:days' && dateRange.endDate === 'today') {
    return 'Compare to previous 7 days';
  }
  if (dateRange.startDate === '-30:days' && dateRange.endDate === 'today') {
    return 'Compare to previous 30 days';
  }
  if (dateRange.startDate === '-3:months' && dateRange.endDate === 'today') {
    return 'Compare to previous 3 months';
  }
  if (dateRange.startDate === '-6:months' && dateRange.endDate === 'today') {
    return 'Compare to previous 6 months';
  }
  if (dateRange.startDate === '-12:months' && dateRange.endDate === 'today') {
    return 'Compare to previous 12 months';
  }
  if (
    dateRange.startDate === `${new Date().getFullYear()}-01-01` &&
    dateRange.endDate === 'today'
  ) {
    return 'Compare to previous year to date';
  }
  return 'Compare to previous period';
};

interface Props {
  compare: boolean;
  setCompare: (compare: boolean) => void;
  dateRange: DateRangeSchema;
}

export const Compare: React.FC<Props> = (props) => {
  const { compare, setCompare, dateRange } = props;

  const label = React.useMemo(() => dateRangeToLabel(dateRange), [dateRange]);

  if (compare) {
    return (
      <div className="flex gap-1 items-center border border-gray-300 p-2 rounded-md bg-white">
        <span className="text-gray-500 text-center">{label}</span>
        <XCircleIcon
          className="h-5 cursor-pointer flex-shrink-0"
          onClick={() => setCompare(false)}
        />
      </div>
    );
  }

  return (
    <ButtonDropdown
      label="Compare"
      items={[
        {
          label,
          onClick: () => setCompare(true),
          active: compare,
        },
      ]}
    />
  );
};
Compare.displayName = 'Shipments.HistoricalPerDiem.Compare';
